import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputCheck from '../../components/Inputs/InputCheck'
import InputNumber from '../../components/Inputs/InputNumber'
import InputRadio from '../../components/Inputs/InputRadio'
import PercentInput from '../../components/Inputs/PercentInput'
import Switch from '../../components/Inputs/Switch'
import { TextArea } from '../../components/Inputs/TextArea'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const AdjustPriceForm: React.FC<IAdjustPriceForm> = ({
  onSubmit,
  onCancel,
}) => {
  const form = useForm({
    defaultValues: {
        percentage: 0,
        services: false,
        items: false
    }
  })

  const { addAlert } = useSnackBars()

//   const [showConfirmModal, setShowConfirmModal] = useState(false)

  const submitForm = (values) => {
    if (!values.items && !values.services) {
      addAlert({
        message: 'Debe de seleccionar al menos un servicio o producto',
        status: 'error',
      })
      return
    }

    onSubmit(values)
  }

  const [checkedServices, setCheckedServices] = useState<boolean>(false)

  const [checkedItems, setCheckedItems] = useState<boolean>(false)


  return (
    <>
    
    <Form form={form} onSubmit={submitForm}>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Ajuste masivo de precios
      </h2>

      <FormItem
        name="percentage"
        classes="xl:col-span-12 col-span-12"
        rules={{ required: 'Es necesario este campo' }}
      >
        {/* <InputNumber label="Porcentaje" /> */}
        <PercentInput label="Porcentaje" />
      </FormItem>

      <FormItem
        name="services"
        classes="xl:col-span-6 col-span-6 mt-3"
      >
        <InputCheck label="Servicios" checked={checkedServices} onChange={() => setCheckedServices(prev => !prev)}  />
      </FormItem>

      <FormItem
        name="items"
        classes="xl:col-span-6 col-span-6 mt-3"
      >
        <InputCheck label="Productos" checked={checkedItems}  onChange={() => setCheckedItems(prev => !prev)} />
      </FormItem>

      <div className="col-span-12 flex mt-5 justify-center">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Guardar cambios
        </Button>
      </div>


    </Form>
      {/* <ModalConfirm title={'¿Está seguro que desea modificar masivamente los productos o servicios?'} body="Modificar masivamente dichos productos afectara en su precio" displayConfirmModal={!!values} onCancel={() => setValues(null)} onConfirm={() => {
        onSubmit(values)
    }}    
    /> */}
    </>
  )
}

interface IAdjustPriceForm {
  onCancel: () => void
  onSubmit: (values: any) => void
}

export default AdjustPriceForm
